import React from 'react';
import { Modal } from 'antd';
import DefaultButton from '../DefaultButton';

interface AlertModalProps {
  title: React.ReactNode;
  visible: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  title,
  visible,
  onCancel,
  onConfirm,
  confirmText = 'Confirmar',
  cancelText = 'Fechar',
  children,
  footer,
  showConfirmButton = true,
  showCancelButton = true,
}) => {
  const renderFooter = () => {
    if (footer) return footer;

    if (showConfirmButton && showCancelButton) {
      return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DefaultButton
            key="cancel"
            width="150px"
            height="35px"
            fontSize="1em"
            withOutBackground={true}
            params={{
              type: 'button',
              onClick: onCancel,
            }}
          >
            {cancelText}
          </DefaultButton>
          <DefaultButton
            key="confirm"
            width="150px"
            height="35px"
            fontSize="1em"
            params={{
              type: 'button',
              onClick: onConfirm,
            }}
          >
            {confirmText}
          </DefaultButton>
        </div>
      );
    }

    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {showCancelButton && (
          <DefaultButton
            key="cancel"
            width="150px"
            height="35px"
            fontSize="1em"
            withOutBackground={true}
            params={{
              type: 'button',
              onClick: onCancel,
            }}
          >
            {cancelText}
          </DefaultButton>
        )}
        {showConfirmButton && onConfirm && (
          <DefaultButton
            key="confirm"
            width="150px"
            height="35px"
            fontSize="1em"
            params={{
              type: 'button',
              onClick: onConfirm,
            }}
          >
            {confirmText}
          </DefaultButton>
        )}
      </div>
    );
  };

  return (
    <Modal
      title={<h3 style={{textAlign: 'center'}}>{title}</h3>}
      open={visible}
      onCancel={onCancel}
      footer={renderFooter()}
      centered
      maskClosable={false}
    >
      <div style={{ textAlign: 'center'}}>
        {children}
      </div>
    </Modal>
  );
};

export default AlertModal;
